import { render, staticRenderFns } from "./purestimate.vue?vue&type=template&id=5ec7ab5e&scoped=true&"
import script from "./purestimate.vue?vue&type=script&lang=js&"
export * from "./purestimate.vue?vue&type=script&lang=js&"
import style0 from "./purestimate.vue?vue&type=style&index=0&id=5ec7ab5e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec7ab5e",
  null
  
)

export default component.exports